define("shared/utils/get-mentions", ["exports", "later/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = getMentions;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   * @extends Utils
   *
   *
   * Finds all valid Instagram username mentions (e.g. @latermedia, @later.media, @_latermedia)
   * in a given string, accounting for whitespace, newlines
   *
   * @method getMentions
   *
   * @param {String} str The string in which to find mentions
   *
   * @returns {Array[String]} The list of mentions found in the input string.
   */

  function getMentions(str) {
    const matches = str?.match(_constants.INSTAGRAM_MENTION_REGEX) || [];
    return matches.map(mention => mention.trim());
  }
});